module.exports = __webpack_public_path__ + "img/footer-linkedin-icon.499b3b5e.svg";